import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { Chat } from "../api/chatApi";
import { withAccessToken } from "src/server/api";
import moment from "moment";

axios.defaults.baseURL = process.env.REACT_APP_FINAN_DOMAIN;

const initialState = {
  listConversationUtils: {
    all: {
      pageConversationList: 1,
      metaConversationList: null,
      isLoading: false,
      list_conversation: null,
    },
    unRead: {
      pageConversationList: 1,
      metaConversationList: null,
      isLoading: false,
      list_conversation: null,
    },
  },
  firstLoadConversation: true,
  isExistConversation: true,
  objConversation: {},
  isRenderConversationList: true,
  searchConversationKey: "",
  conversationSearchList: null,
  drawerToggle: false,
  checkBox: "all",
  conversation_present: {},
};

const slice = createSlice({
  name: "conversation",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },
    hasDone(state, action) {
      state.isLoading = false;
    },

    updatePageConversationList(state, action) {
      const { payload } = action;
      state.listConversationUtils[state.checkBox].pageConversationList =
        payload;
    },

    setIsExistConversation(state, action) {
      const { payload } = action;
      state.isExistConversation = payload;
    },

    updateConversation(state, action) {
      const { payload } = action;
      state.listConversationUtils[state.checkBox].list_conversation = payload;
    },

    setIsRenderConversationList(state, action) {
      const { payload } = action;
      state.isRenderConversationList = payload;
    },

    setFilterConversationBySearch(state, action) {
      const { payload } = action;
      state.searchConversationKey = payload;
    },

    setConversationSearchList(state, action) {
      const { payload } = action;
      state.conversationSearchList = payload;
    },

    setDrawerToggle(state, action) {
      const { payload } = action;
      state.drawerToggle = payload;
    },

    setCheckBox(state, action) {
      const { payload } = action;
      state.checkBox = payload;
    },

    setConversationPresent(state, action) {
      const { payload } = action;
      state.conversation_present = payload;
    },

    sortListConversation(state, action) {
      const { payload } = action;
      if (payload && payload.indexRemove >= 0) {
        state.listConversationUtils[state.checkBox].list_conversation.splice(
          payload.indexRemove,
          1
        );
        state.listConversationUtils[state.checkBox].list_conversation.unshift(
          payload
        );
        state.isRenderConversationList = false;
      } else {
        if (state.listConversationUtils[state.checkBox].list_conversation) {
          state.listConversationUtils[state.checkBox].list_conversation.unshift(
            payload
          );
        } else {
          state.listConversationUtils[state.checkBox].list_conversation = [
            payload,
          ];
        }
      }
    },

    getConversationSuccess(state, action) {
      const { payload } = action;
      let status = "";
      if (payload.status === "unread") {
        status = "unRead";
      } else {
        status = "all";
      }

      state.listConversationUtils[status].metaConversationList = payload.meta;
      if (state.listConversationUtils[status].list_conversation) {
        const removeDulicate = payload.data.filter((obj) => {
          return (
            state.listConversationUtils[status].list_conversation.findIndex(
              (item) => item.id === obj.id
            ) === -1
          );
        });
        const sortConversation = [
          ...state.listConversationUtils[status].list_conversation,
          ...removeDulicate,
        ].sort((a, b) => {
          const date_one = moment(b.latest_message?.updated_at).unix();
          const date_two = moment(a.latest_message?.updated_at).unix();

          return date_one - date_two;
        });

        state.listConversationUtils[status].list_conversation =
          sortConversation || [];
      } else {
        const sortConversation = [...payload.data].sort((a, b) => {
          const date_one = moment(b.latest_message?.updated_at).unix();
          const date_two = moment(a.latest_message?.updated_at).unix();
          return date_one - date_two;
        });

        state.listConversationUtils[status].list_conversation =
          sortConversation || [];
      }
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function upDateRMessage(params = {}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Chat.upDateRMessage(
        (params = { ...params, read_all: true }),
        {
          headers: await withAccessToken({
            "Content-Type": "text/plain",
          }),
        }
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    } finally {
      dispatch(slice.actions.hasDone());
    }
  };
}

export function setConversationPresent(info) {
  return (dispatch) => {
    dispatch(slice.actions.setConversationPresent(info));
  };
}

export function setNewConversation(list_conversation) {
  return (dispatch) => {
    dispatch(slice.actions.updateConversation(list_conversation));
  };
}

export function updatePageConversationList(page) {
  return (dispatch) => {
    dispatch(slice.actions.updatePageConversationList(page));
  };
}

export function setIsExistConversation(isExist) {
  return (dispatch) => {
    dispatch(slice.actions.setIsExistConversation(isExist));
  };
}

export function setIsRenderConversationList(isRenderConversationList) {
  return (dispatch) => {
    dispatch(
      slice.actions.setIsRenderConversationList(isRenderConversationList)
    );
  };
}

export function setFilterConversationBySearch(searchConversationKey) {
  return (dispatch) => {
    dispatch(
      slice.actions.setFilterConversationBySearch(searchConversationKey)
    );
  };
}

export function setConversationSearchList(conversationSearchList) {
  return (dispatch) => {
    dispatch(slice.actions.setConversationSearchList(conversationSearchList));
  };
}

export function setDrawerToggle(drawerToggle) {
  return (dispatch) => {
    dispatch(slice.actions.setDrawerToggle(drawerToggle));
  };
}

export function setCheckBox(checkBox) {
  return (dispatch) => {
    dispatch(slice.actions.setCheckBox(checkBox));
  };
}

export function getOneConversation(
  id,
  unreadMessage,
  latestMessageCustom,
  idChatCurrent
) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const config = await withAccessToken({
        "Content-Type": "application/json;charset=UTF-8",
      });

      const response = await Chat.getOneConversation(
        {
          headers: config,
        },
        id
      );

      if (response?.data) {
        const isInConversation = response?.data.participants.find(
          (item) => item.sender_id === idChatCurrent
        );

        if (!isInConversation) return;

        const newReponse = {
          ...response?.data,
          countUnreadMessage: unreadMessage,
          latest_message_custom: latestMessageCustom,
          time_message_come: new Date(),
        };

        dispatch(slice.actions.sortListConversation(newReponse));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    } finally {
      dispatch(slice.actions.hasDone());
    }
  };
}

export function getOneConversationOut(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const config = await withAccessToken({
        "Content-Type": "application/json;charset=UTF-8",
      });

      const response = await Chat.getOneConversation(
        {
          headers: config,
        },
        id
      );

      if (response?.data) {
        return response;
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    } finally {
      dispatch(slice.actions.hasDone());
    }
  };
}

export function getOneConversationNotExistInList(params) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const config = await withAccessToken({
        "Content-Type": "application/json;charset=UTF-8",
      });

      const response = await Chat.getOneConversationNotExistInList({
        params: params,
        headers: config,
      });

      if (response?.data) {
        dispatch(slice.actions.sortListConversation(response?.data ?? []));
        dispatch(setConversationPresent(response?.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    } finally {
      dispatch(slice.actions.hasDone());
    }
  };
}

export function getConversations(params, paramsUnread) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const config = await withAccessToken({
        "Content-Type": "application/json;charset=UTF-8",
      });

      await Chat.listConversation({
        params: params,
        headers: config,
      }).then((conversation) => {
        if (params.status === "unread") {
          Promise.all(
            conversation.data.map((item, index) => {
              return getCountMessage(paramsUnread, conversation, index);
            })
          )
            .then((responses) => {
              const conversationBusinessArr = responses?.map((item) => {
                return item.data.index.includes("business") && item.data;
              });

              const conversationBusiness = {
                data: [...conversationBusinessArr],
                meta: responses[0]?.meta,
                status: "unread",
              };
              dispatch(
                slice.actions.getConversationSuccess(conversationBusiness ?? [])
              );
            })
            .catch((error) => {
              dispatch(slice.actions.hasError(error));
            });
        } else {
          const conversationBusiness = {
            data:
              conversation && conversation.data
                ? conversation?.data?.map((value) => ({
                    ...value,
                    countUnreadMessage: {
                      count: 0,
                      conversation_id: value.id,
                    },
                  }))
                : [],
            meta: conversation.meta,
          };

          dispatch(
            slice.actions.getConversationSuccess(conversationBusiness ?? [])
          );
        }
        // return conversationArr;
      });
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    } finally {
      dispatch(slice.actions.hasDone());
    }
  };
}

export async function getCountMessage(paramsUnread, conversation, index) {
  try {
    const config = await withAccessToken({
      "Content-Type": "application/json;charset=UTF-8",
    });

    const response = await Chat.countUseenMessage({
      params: {
        ...paramsUnread,
        conversation_id: conversation.data[index].id,
      },
      headers: config,
    });

    const conversationCustom = {
      data: {
        ...conversation.data[index],
        countUnreadMessage: {
          ...response?.data,
          conversation_id: conversation.data[index].id,
        },
      },

      meta: conversation.meta,
    };
    return conversationCustom;
  } catch (error) {
    console.log(error);
  }
}

export async function getUnReadMessageInFile(params) {
  try {
    const config = await withAccessToken({
      "Content-Type": "application/json;charset=UTF-8",
    });
    const response = await Chat.countUseenMessage({
      params: params,

      headers: config,
    });

    if (Object.keys(response?.data).length > 0) {
      return response?.data;
    }
  } catch (error) {
    console.log(error);
  }
}

export function handleUnreadMessage({
  chat,
  businessId,
  conversationPresentId,
  isExistConversation,
  indexRemove,
  idChatCurrent,
}) {
  return async (dispatch) => {
    if (chat[0]?.body?.conversation_id) {
      if (!isExistConversation) {
        Promise.all(
          chat?.map((item) => {
            return getUnReadMessageInFile({
              sender_id:
                item.body?.receiver_type === "business" ? businessId : item.to,
              sender_type: item.body?.receiver_type,
              conversation_id: item.body?.conversation_id,
            });
          })
        )
          .then((responses) => {
            responses[0].conversation_id = chat[0]?.body?.conversation_id;
            dispatch(
              getOneConversation(
                chat[0]?.body?.conversation_id,
                responses[0],
                chat[0]?.body.content,
                idChatCurrent
              )
            );
          })
          .catch((error) => {
            dispatch(slice.actions.hasError(error));
          });
      } else if (
        indexRemove !== null &&
        isExistConversation &&
        chat[0]?.body?.conversation_id !== conversationPresentId
      ) {
        dispatch(
          slice.actions.sortListConversation({
            ...isExistConversation,
            indexRemove: indexRemove,
            countUnreadMessage: {
              ...isExistConversation.countUnreadMessage,
              count: isExistConversation.countUnreadMessage.count + 1,
            },
            latest_message_custom: chat[0]?.body.content,
            time_message_come: new Date(),
          })
        );
      }
    }
  };
}
